/* eslint-disable guard-for-in */
/* eslint-disable padding-line-between-statements */
/* eslint-disable arrow-body-style */
import { useTranslator } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { WizardPageTemplate } from 'gw-portals-wizard-components-ui';
import _, { update } from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Icon, InlineNotification, Loader, useModal } from '@jutro/components';
import { withRouter } from 'react-router-dom';
import appConfig from 'app-config';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { TFPAWizardTemplate } from 'tfpa-portals-wizard-components-ui';
import GatewayFNOLService from '../../../../capabilities/twia-capability-gateway-fnol/services/GatewayFNOLService';
import LossDamageUtil from '../../utils/LossDamageUtil';
import Address from '../../models/Address';
import { AddressStandardizationServiceCC } from 'twia-capability-fnol-addressstandardization';
import addressControl from 'twia-capability-address-component/util/addressControl';
import { TWIAAddressComponent } from 'twia-capability-address-component';
import FNOLAdditonalLossdetailsPage from '../AdditionalLossdetails/AdditionalLossdetailsPage';
import { wizardMessages } from 'tfpa-portals-wizard-components-ui';
import "@fortawesome/fontawesome-free/css/all.min.css"; 
import messages from './LossDetailsPage.messages';
import styles from './LossDetailsPage.module.scss';
import metadata from './LossDetailsPage.metadata.json5';

import { CheckboxField } from '@jutro/legacy/components';

const fnolAdditonalLossdetailsPage = {
    id: 'details',
    path: '/details',
    component: FNOLAdditonalLossdetailsPage,
    stepProps: {
        template: TFPAWizardTemplate,
    },
    title: messages.additionalLossPageTitle,
};

function LossDetailsPage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} },
        },
        changeNextSteps,
        steps,
        currentStepIndex
    } = props;
    const translator = useTranslator();
    const { showAlert, showConfirm } = useModal();
    const viewModelService = useContext(ViewModelServiceContext);
    const [showErrors, setShowErrors] = useState(false);
    const [selectedHail, setSelectedHail] = useState(false);
    const [selectedWind, setSelectedWind] = useState(false);
    const [selectedBoth, setSelectedBoth] = useState(false);
    const [selectedLossCause, setSelectedLossCause] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('primaryInsuredLocationId');
    const otherLossLocationTfpaVM = viewModelService.create(
        new Address(),
        'cc',
        'edge.capabilities.address.dto.AddressDTO'
    );
    const [addressVM, setAddressVM] = useState(otherLossLocationTfpaVM);
    const [ccConstants, setCCConstants] = useState([]);
    const [isStandardizationDisabled, setIsStandardizationDisabled] = useState(false);
    const [isButtonDisabled, updateDisablity] = useState(false);
    const [invalidComponent, setInvalidComponents] = useState([]);
    const [isAddressEdited, setIsAddressEdited] = useState(false);
    const [checkAllValue, setCheckAllValue] = useState(false);
    // DE16586
    const [lossCauseDisable, setLossCauseDisable] = useState();
    const [disableNextValue, setDisableNextValue] = useState();
    const [aleastOneMsg, setAleastOneMsg] = useState();
    const [checkValueMsg, setCheckValueMsg] = useState(true);
    const [lossDamagesLoc, setLossDamagesLoc] = useState([]);
    const [lossDamageTableData, setLossDamageTableData] = useState([]);
    const [removedRiskUnitsList, setRemovedRiskUnitsList] = useState([]);

    const { authHeader, authUserData } = useAuthentication();
    const [isLoading, setIsLoading] = useState(false);
    const {
        onValidate,
        isComponentValid,
        initialValidation,
        disregardFieldValidation
    } = useValidation('LossDetailsPage');
    const losscause = _.get(claimVM, 'lossCause.value.code')
    const { refreshData } = useDataRefresh();
    const policyTypelist = viewModelService.productMetadata.get('cc').types.getTypelist('PolicyType')
    const policyType = _.get(claimVM, 'policy.policyType.value'); //DE17006
    console.log('ClaimVM', claimVM);
    const commercialPolicyType = policyTypelist.getFilter('PolicyTypes_TWIAPC9Commercial').codes.find(code => code.code === policyType);
    const isCommercial = !_.isUndefined(commercialPolicyType);
    const isTFPA = authUserData?.associationName_TWIA === 'tfpa';
    const country = _.get(otherLossLocationTfpaVM, 'country.value.code');
    const xPortal = 'CC';
    const noAdditionalLossCauseValues = ['smoke_TFPA', 'aircraftveh_TFPA', 'explosion', 'riotandcivil', 'notlisted_TFPA', 'lightning_TFPA'];
    const isWindandHail = ['bothExt', 'wind', 'hail'].includes(_.get(claimVM.value, 'lossCause'))
    const breakpoint = useContext(BreakpointTrackerContext);
    const isPhone = breakpoint === 'phoneWide' || breakpoint === 'phone';
    const isTablet = breakpoint === "tablet";


    useEffect(() => {
        claimVM.lossDamagesExt.value = _.isUndefined(claimVM.lossDamagesExt.value) ? [] : claimVM.lossDamagesExt.value;

        if (isCommercial) {
            if (isCommercial && !claimVM.lobs.commercialProperty.dateOfNotice.value) {
                claimVM.lobs.commercialProperty.dateOfNotice.value = claimVM.lossDate.value;
            }

            if (isCommercial) {
                setDisableNextValue(true);
                setAleastOneMsg(true);
                setCheckValueMsg(true);
                getLocationBasedRisksExt();
            } else {
                const locationBasedRisksExt = _.get(claimVM, 'lossDamagesExt.value')

                if (locationBasedRisksExt.length === 1) {
                    setAleastOneMsg(false);
                    setCheckValueMsg(false);
                }

            }

            if (_.isUndefined(claimVM.lossCause.value)) {

                setLossCauseDisable(true);
            }

            tableLossDamageData()
        }

        if (_.get(claimVM.value, 'isOtherLossLocation_TFPA')) {
            setSelectedLocation('otherLocId');
            const { addressLine1, addressLine2, addressLine3, city, state, postalCode, country, addressVerifyStatusExt, addressStandResult } = _.get(claimVM.value, 'otherLossLocation_TFPA');
            const updatedAddressVM = otherLossLocationTfpaVM;
            _.set(updatedAddressVM, 'addressLine1.value', addressLine1);
            _.set(updatedAddressVM, 'addressLine2.value', addressLine2);
            _.set(updatedAddressVM, 'addressLine3.value', addressLine3);
            _.set(updatedAddressVM, 'city.value', city);
            _.set(updatedAddressVM, 'state.value', state);
            _.set(updatedAddressVM, 'postalCode.value', postalCode);
            _.set(updatedAddressVM, 'country.value', country);
            _.set(updatedAddressVM, 'addressVerifyStatusExt.value', addressVerifyStatusExt);  //DE17536 & DE17538
            updatedAddressVM.value.addressStandResult = addressStandResult;
            setAddressVM(updatedAddressVM);
        }
        
        // DE17213
        if (!_.get(claimVM.value, 'isOtherLossLocation_TFPA') && !isCommercial) {
            const firstLoc = _.first(_.get(claimVM, 'policy.lobs.homeowner.locations.value'));

            claimVM.lossLocation.value = (firstLoc && firstLoc.locationAddress) ? firstLoc.locationAddress : {};
        }

        updateWizardData(claimVM);
        lossClauseSelection(losscause);
        getCCConstants();
    },[]);

    const getCCConstants = useCallback(async () => {
        const constants = await AddressStandardizationServiceCC.getCCPortalConstants(authHeader);

        if (!constants.portalAddressStandardizationEnabled) {
            setIsStandardizationDisabled(true);
            updateDisablity(true);
        }

        setCCConstants(constants);
    }, []);


    const getLocationBasedRisksExt = useCallback(() => {
        const claimNumber = claimVM.claimNumber.value;
        const lossDamage = _.get(claimVM, 'lossDamagesExt.value')
        let locationBasedRisksExt = [];

        GatewayFNOLService.getLocationBasedRUs(claimNumber, false, authHeader).then(locationBasedRisks => {
            const lossItem = vmDTO();

            locationBasedRisksExt = locationBasedRisks;

            if (lossDamage.length > 0) {
                for (const riskIdx in lossDamage) {
                    const risk = lossDamage[riskIdx].locationBasedRU;
                    if (risk.selected) {
                        locationBasedRisksExt[riskIdx].selected = true;

                    }
                }
                setDisableNextValue(false);
            }

            let newLossDamage

            if (locationBasedRisksExt) {
                for (const riskIdx in locationBasedRisksExt) {
                    const risk = locationBasedRisksExt[riskIdx];
                    if (risk.hasLossDamageReport) {
                        locationBasedRisksExt[riskIdx].selected = true;
                        setDisableNextValue(false);
                        newLossDamage = _.clone(lossDamage)
                    }
                }

            }

            if (locationBasedRisks.length === 1) {
                locationBasedRisksExt[0].selected = true;
                setDisableNextValue(false);
                setAleastOneMsg(false);
                setCheckValueMsg(false);
            }

            if (lossDamage.length === 0 || newLossDamage) {
                _.set(claimVM, 'lossDamagesExt.value', locationBasedRisks)
                LossDamageUtil.getLossDamageCommercial(vmDTO, locationBasedRisks, isCommercial, claimVM, updateWizardData, newLossDamage, refreshData);
            }

            tableLossDamageData()
            updateWizardData(claimVM);

            return claimVM
        }).catch((err) => {
            // return claimVM
        })
    }, [])

    const tableLossDamageData = useCallback(() => {
        const lossDamage = _.get(claimVM, 'lossDamagesExt.value')

        let lossDamageData = []

        if (!_.isUndefined(lossDamage)) {
            if (lossDamage.length !== 0) {
                lossDamage.forEach(element => {
                    lossDamageData.push(element.locationBasedRU)
                });
                setLossDamageTableData(lossDamageData);
            }

        }
    },
        [claimVM]
    );


    const handleClick = useCallback(
        (value, path, index) => {
            _.set(claimVM.lossDamagesExt.value[index].locationBasedRU, 'selected', value);

            if (!value) {
                setCheckAllValue(false);
            }

            updateWizardData(claimVM);

            const locationsSelected = _.find(claimVM.lossDamagesExt.value, (field) => field.locationBasedRU.selected === true);

            if (locationsSelected) {
                setDisableNextValue(false)
                setAleastOneMsg(false)
            } else {
                setDisableNextValue(true)
                setAleastOneMsg(true)
            }

            refreshData();
        },
        [claimVM, lossDamageTableData, refreshData, updateWizardData]
    );

    const getCheckBox = useCallback(
        (item, index) => (
            <CheckboxField
                name={item.displayName}
                label="Check to indicate damage"
                id={item.displayName}
                value={item.selected}
                showInlineLabel
                onValueChange={e => handleClick(e, item, index)}
            />
        ),
        []
    );

    const getCheckedAll = useCallback((value) => {
        if (value) {
            setCheckAllValue(true);
            setDisableNextValue(false);
            setAleastOneMsg(false);
        }
        else {
            setCheckAllValue(false);
            setDisableNextValue(true);
            setAleastOneMsg(true);
        }

        // eslint-disable-next-line guard-for-in
        for (const riskIdx in lossDamageTableData) {
            const risk = lossDamageTableData[riskIdx];

            risk.selected = value;
        }

        updateWizardData(claimVM);
        refreshData();
    }, [claimVM, lossDamageTableData, refreshData, updateWizardData]);

    const removedRiskUnits = useCallback(() => {

        for (const riskIdx in lossDamageTableData) {
            const locationBasedRisk = lossDamageTableData[riskIdx];

            if (locationBasedRisk.selected) {
                if (lossDamagesLoc.indexOf(locationBasedRisk.publicID) === -1) {
                    lossDamagesLoc.push(locationBasedRisk.publicID);
                    setLossDamagesLoc(lossDamagesLoc);
                }
            } else {
                if (lossDamagesLoc.indexOf(locationBasedRisk.publicID) !== -1) {
                    lossDamagesLoc.splice(lossDamagesLoc.indexOf(locationBasedRisk.publicID), 1);
                }

                removedRiskUnitsList.push(locationBasedRisk.publicID);
                setRemovedRiskUnitsList(removedRiskUnitsList);
            }
        }
    }, [lossDamageTableData, lossDamagesLoc, removedRiskUnitsList])

    const onToggleChange = useCallback((value, path) => {
        _.set(claimVM, path, value);
        updateWizardData(claimVM)
    }, [claimVM, updateWizardData])

    const selectLossCause = useCallback(clause => () => {
        const lossCauseValue = _.get(claimVM, 'lossCause.value.code')

        if (isTFPA) {
            if (lossCauseValue !== clause && !_.isUndefined(lossCauseValue)) {
                const windAndHailLossValues = ['bothExt', 'wind', 'hail'];

                if ((windAndHailLossValues.includes(clause) && !windAndHailLossValues.includes(lossCauseValue)
                    && _.get(claimVM, 'lossDamagesExt.value[0].publicID') && state?.isLossDamageDeletedFromApi)
                    || windAndHailLossValues.includes(lossCauseValue) && !windAndHailLossValues.includes(clause)) {
                    _.set(claimVM, 'lossDamagesExt.value', []);
                }

                if (!_.isUndefined(_.get(claimVM.value, 'lobs.homeowners'))) {
                    _.set(claimVM, 'lobs.homeowners.propertyFireDamage.value', undefined);
                    _.set(claimVM, 'lobs.homeowners.propTheftVanDamageDTO_TFPA.value', undefined);
                    _.set(claimVM, 'lobs.homeowners.propertyWaterDamage.value', undefined);
                }
            }
        }
        _.set(claimVM, 'lossCause.value', clause)

        lossClauseSelection(clause);
        setLossCauseDisable(false);
        updateWizardData(claimVM);

    }, [claimVM]);

    const lossClauseSelection = useCallback((clause) => {
        if (clause === 'hail') {
            setSelectedHail(true)
        } else {
            setSelectedHail(false)
        }

        if (clause === 'wind') {
            setSelectedWind(true)
        } else {
            setSelectedWind(false)
        }

        if (clause === 'bothExt') {
            setSelectedBoth(true)
        } else {
            setSelectedBoth(false)
        }

        setSelectedLossCause(clause);

    }, []);

    // DE16588
    const checkBoxMessage = () => {
        return (
            <div>
                <span style={{ display: 'flex' }}>
                    <Icon id="icon" icon="gw-info" />
                    <span style={{ paddingLeft: '6px' }}>{translator(messages.checkBoxMessage)}</span>
                </span>
            </div>
        );
    };

    const getActiveCardClass = (id) => {
        return id === selectedLossCause;
    };

    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    const setDisablity = useCallback((value) => {
        if (!isStandardizationDisabled) {
            updateDisablity(false);
        }
        else {
            updateDisablity(addressControl.isStdBtnAvailable(value, xPortal))
        }
    }, [updateDisablity]);

    const updatePolicyAddressVM = useCallback((addrssVM) => {
        if (addrssVM) {
            _.set(claimVM, 'otherLossLocation_TFPA', addrssVM);
            _.set(claimVM, 'lossLocation', addrssVM);
            setDisablity(addrssVM);
            if (addrssVM?.addressVerifyStatusExt === 'validated') {
                _.set(claimVM, 'otherLossLocation_TFPA.isValidated_Ext', true);
                setIsAddressEdited(false);
                updateWizardData(claimVM);
                setAddressVM(claimVM.otherLossLocation_TFPA);
            } else if (addrssVM?.addressVerifyStatusExt === 'overridden') {
                _.set(claimVM, 'otherLossLocation_TFPA.isOverridden_Ext', true);
                setIsAddressEdited(false);
                updateWizardData(claimVM);
                setAddressVM(claimVM.otherLossLocation_TFPA);
            }
            updateWizardData(claimVM);
        }

    }, [claimVM, updateWizardData, setDisablity]);

    const handleAddressEditing = useCallback((val) => {
        setIsAddressEdited(val);
    });

    const handleOtherLoc = useCallback((value) => {
        setSelectedLocation(value)
        _.set(claimVM.value, 'isOtherLossLocation_TFPA', true);
        _.set(otherLossLocationTfpaVM, 'addressVerifyStatusExt.value', 'notvalidated');  //  DE17536 & DE17538
         _.set(otherLossLocationTfpaVM, 'country.value', 'US');
         _.set(otherLossLocationTfpaVM, 'mustStandardize_Ext.value', true);
        setAddressVM(otherLossLocationTfpaVM);
        setIsAddressEdited(false);
        setShowErrors(false);
        updateWizardData(claimVM);
        if(_.get(addressVM, 'addressVerifyStatusExt.value') === undefined){
            _.set(addressVM, 'addressVerifyStatusExt.value', 'notvalidated'); // DE17150
            setAddressVM(addressVM);
        }
    },[addressVM, claimVM]);

    const handlePrimInsLoc = useCallback((value) => {
        setSelectedLocation(value);
        addressVM.value = {};  //DE17536 & DE17538
        setAddressVM(addressVM);
        setInvalidComponents([]);
        disregardFieldValidation('TWIAAddressComponent');
        _.set(claimVM.value, 'otherLossLocation_TFPA', undefined);
        _.set(claimVM.value, 'isOtherLossLocation_TFPA', undefined);
        const firstLoc = _.first(_.get(claimVM, 'policy.lobs.homeowner.locations.value'));
        _.set(claimVM.value, 'lossLocation', (firstLoc && firstLoc.locationAddress) ? firstLoc.locationAddress : {});
        updateWizardData(claimVM);
    });

    const overrideProps = {
        '@field': {
            showErrors
        },
        clickableCard: {
            onClick: selectLossCause('hail'),
            className: selectedHail
                ? styles.activeButton
                : styles.buttonClass,
        },
        clickableCard2: {
            onClick: selectLossCause('wind'),
            className: selectedWind
                ? styles.activeButton
                : styles.buttonClass,
        },
        clickableCard3: {
            onClick: selectLossCause('bothExt'),
            className: selectedBoth
                ? styles.activeButton
                : styles.buttonClass,
        },
        clickableCard4: {
            onClick: selectLossCause('lightning_TFPA'),
            className: getActiveCardClass('lightning_TFPA')
                ? styles.activeButton
                : styles.buttonClass,
            visible: isTFPA
        },
        clickableCard5: {
            onClick: selectLossCause('waterdamage'),
            className: getActiveCardClass('waterdamage')
                ? styles.activeButton
                : styles.buttonClass,
            visible: isTFPA
        },
        clickableCard6: {
            onClick: selectLossCause('burglary'),
            className: getActiveCardClass('burglary')
                ? styles.activeButton
                : styles.buttonClass,
            visible: isTFPA
        },
        clickableCard7: {
            onClick: selectLossCause('fire'),
            className: getActiveCardClass('fire')
                ? styles.activeButton
                : styles.buttonClass,
            visible: isTFPA
        },
        clickableCard8: {
            onClick: selectLossCause('vandalism'),
            className: getActiveCardClass('vandalism')
                ? styles.activeButton
                : styles.buttonClass,
            visible: isTFPA
        },
        clickableCard9: {
            onClick: selectLossCause('aircraftveh_TFPA'),
            className: getActiveCardClass('aircraftveh_TFPA')
                ? styles.activeButton
                : styles.buttonClass,
            visible: isTFPA
        },
        clickableCard10: {
            onClick: selectLossCause('smoke_TFPA'),
            className: getActiveCardClass('smoke_TFPA')
                ? styles.activeButton
                : styles.buttonClass,
            visible: isTFPA
        },
        clickableCard11: {
            onClick: selectLossCause('explosion'),
            className: getActiveCardClass('explosion')
                ? styles.activeButton
                : styles.buttonClass,
            visible: isTFPA
        },
        clickableCard12: {
            onClick: selectLossCause('riotandcivil'),
            className: getActiveCardClass('riotandcivil')
                ? styles.activeButton
                : styles.buttonClass,
            visible: isTFPA
        },
        clickableCard13: {
            onClick: selectLossCause('liability_TFPA'),
            className: getActiveCardClass('liability_TFPA')
                ? styles.customActiveButton
                : styles.customButtonClass,
            visible: isTFPA
        },
        clickableCard14: {
            onClick: selectLossCause('notlisted_TFPA'),
            className: getActiveCardClass('notlisted_TFPA')
                ? styles.customActiveButton
                : styles.customButtonClass,
            visible: isTFPA
        },
        userRolesTable: {
            data: lossDamageTableData

        },
        emergencyServicesSection: {
            visible: !isCommercial
        },
        lossOccurSection: {
            visible: !isCommercial
        },
        OccupancyLossLocSection: {
            visible: !isCommercial
        },
        describedLabel: {
            visible: isCommercial
        },
        checkBoxTextSection: {
            visible: isCommercial
        },
        userRolesTableGridDiv: {
            visible: isCommercial
        },
        checkAll: {
            value: checkAllValue
        },
        checkBoxText2: {
            content: checkBoxMessage(),
            visible: aleastOneMsg
        },
        checkAllTextSection: {
            visible: checkValueMsg && isCommercial
        },
        checkBoxText: {
            visible: checkValueMsg
        },
        bothHail: {
            content: isCommercial ? translator(messages.bothWindHail) : translator(messages.bothWindandHail)
        },
        locationRadioContainer: {
            visible: isTFPA
        },
        priInsLocation: {
            visible: !isTFPA
        },
        primInsLocation: {
            visible: isTFPA && selectedLocation === 'primaryInsuredLocationId'
        },
        primaryInsLocationField: {
            value: selectedLocation,
            onValueChange: handlePrimInsLoc
        },
        otherLocField: {
            value: selectedLocation,
            onValueChange: handleOtherLoc
        },
        otherLocAddressComponent: {
            addressVM, updatePolicyAddressVM, country, showErrors, findInvalidComponent, onValidate,
            companyType: 'tfpa',
            xPortal,
            ccConstants,
            isStandardizationDisabled,
            onAddressEdit: handleAddressEditing,
            visible: isTFPA && selectedLocation === 'otherLocId',
            isLossLocation: true
        },
        emergencyIssues: {
            className: (isPhone || isTablet) ? styles.textBoxClass : styles.toggleClass
        },
        locationRented: {
            className: (isPhone || isTablet) ? styles.textBoxClass : styles.toggleClass
        },
        lossLocationVacant: {
            className: (isPhone || isTablet) ? styles.textBoxClass : styles.toggleClass
        },
        cardContainer: {
            className: isPhone ? styles.cardContainerMobile : isTablet ? styles.cardContainerTablet : styles.cardContainer
        }

    };


    const vmDTO = useCallback((data) => viewModelService.create(data || {}, 'cc', 'ext.TWIA.edge.capabilities.claim.dto.LossDamageExtDTO'), [viewModelService])

    // DE16587, DE16638
    const onNext = useCallback(async () => {
        const lossCauseValue = _.get(claimVM, 'lossCause.value.code')

        const detailsPageIndex = steps.findIndex((step) => step.path === '/details');
        let remainingSteps = steps;

        if (isTFPA && noAdditionalLossCauseValues.includes(lossCauseValue) && detailsPageIndex >= 0) {
            remainingSteps = steps.filter((step, index) => index >= detailsPageIndex + 1);
            changeNextSteps(remainingSteps);
        } else if (isTFPA && !noAdditionalLossCauseValues.includes(lossCauseValue) && detailsPageIndex === -1) {
            steps.splice(currentStepIndex + 1, 0, fnolAdditonalLossdetailsPage);
            remainingSteps = steps.filter((step, index) => index > currentStepIndex);
            changeNextSteps(remainingSteps);
        }

        if (!isComponentValid || invalidComponent.length > 0) {
            setShowErrors(true)

            return false
        }

        setIsAddressEdited(false);
        setShowErrors(false);

        setIsLoading(true)

        if (lossCauseValue === undefined || lossCauseValue === "") {
            return showAlert({
                title: "Error",
                message: messages.lossCauseText,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.close,
            }).then(() => false)
        }

        const claimNumber = _.get(claimVM, 'claimNumber.value');

        if (!isCommercial && isWindandHail) {
            const riskPublic = _.get(claimVM, 'policy.lobs.homeowner.riskUnits_TFPA.value[0].publicID');

            if (claimVM.lossDamagesExt.value.length === 0) {

                const response = await GatewayFNOLService.getLossDamageExtDTO(claimNumber, riskPublic, authHeader)

                setIsLoading(false);

                return LossDamageUtil.getLossDamage(vmDTO, response, isCommercial, claimVM, updateWizardData, refreshData);

            }
            else {
                const existingLossDamagesExt = []

                existingLossDamagesExt.push(vmDTO(claimVM.lossDamagesExt.value[0]).value)
                claimVM.lossDamagesExt.value = existingLossDamagesExt;
                updateWizardData(claimVM);
                refreshData();

                return claimVM;
            }
        }

        if (isCommercial) {
            removedRiskUnits()

            const [riskpublic] = lossDamagesLoc

            GatewayFNOLService.deleteClaimLossDamageExtByLocationRU(
                claimNumber, removedRiskUnitsList, authHeader
            ).then(() => {

            })

            const response = await GatewayFNOLService.getLossDamageExtDTO(claimNumber, riskpublic, authHeader)

            setIsLoading(false);

            return LossDamageUtil.getLossDamage(vmDTO, response, isCommercial, claimVM, updateWizardData, refreshData);


        }
        return claimVM;

    }, [claimVM, isComponentValid, isCommercial, showAlert,
        authHeader, vmDTO, updateWizardData, refreshData, removedRiskUnits,
        lossDamagesLoc, removedRiskUnitsList, invalidComponent, steps])

    const resolvers = {
        resolveComponentMap: {
            addressComponent: TWIAAddressComponent
        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            selectLossCause,
            onValidate,
            getCheckBox,
            onToggleChange,
            getCheckedAll
        },
    };

    return (

        <WizardPage
            onNext={onNext}
            isLoadingNext={isLoading} // DE16587, DE16638
            cancelLabel={translator(messages.fnolSaveandExit)}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
            disableNext={isCommercial ? !isComponentValid || disableNextValue || lossCauseDisable : false || isAddressEdited || isButtonDisabled}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
            />
        </WizardPage>

    );
}

LossDetailsPage.propTypes = wizardProps;
export default withRouter(LossDetailsPage);